import $ from 'jquery';
import getCurrentDate from '../helpers/get-current-date';
import { getCountryCode } from 'countries-list'

function subscribeForm() {

  var theForm = $('#webform-submission-join-our-community-node-42-add-form');

  if (theForm.length) {
    //Our hidden fields that we wnat to submit.
    var firstName = theForm.find('input[name="firstname"]');
    var lastName = theForm.find('input[name="lastname"]');
    var birthDate = theForm.find('input[name="birthdate"]');
    var locationofresidence = theForm.find('input[name="locationofresidence"]');
    // var optinRelational = theForm.find('input[name="optinrelational"]');
    var market = theForm.find('input[name="market"]');
    var dateOptinEmailChannel = theForm.find('input[name="dateoptinemailchannel"]');

    //The fields that will deliver content to the above fields.
    var baseFirstName = $('#edit-name-first');
    var baseLastName = $('#edit-name-last');
    var baseDOBMonth = $('#edit-date-of-birth-items-0-month');
    var baseDOBDay = $('#edit-date-of-birth-items-0-day');
    var baseDOBYear = $('#edit-date-of-birth-items-0-year');
    var baseCountry = $('#edit-country-country');

    //Set date to todays.
    dateOptinEmailChannel.val(getCurrentDate());
   
    baseCountry.on('change', function () {
      console.log($(this).val());      
      var code = getCountryCode($(this).val());
      console.log(code);
      locationofresidence.val(code);
      market.val(code);     
    });

    baseFirstName.on('keyup', function () {
      console.log($(this).val());
      firstName.val($(this).val());
    });

    baseLastName.on('keyup', function () {
      console.log($(this).val());
      lastName.val($(this).val());
    });

    function setDOB(year, month, day) {
      var DOB = baseDOBYear.val() + '-' + baseDOBMonth.val() + '-' + baseDOBDay.val();
      birthDate.val(DOB);
      console.log(DOB);
      return DOB;
    }

    baseDOBMonth.on('keyup', function () {
      console.log(
        baseDOBYear.val() + '-' + $(this).val() + '-' + baseDOBDay.val(),
      );
      setDOB(baseDOBYear.val(), $(this).val(), baseDOBDay.val());
    });

    baseDOBYear.on('keyup', function () {
      console.log(
        $(this).val() + '-' + baseDOBMonth.val() + '-' + baseDOBDay.val(),
      );
      setDOB($(this).val(), baseDOBMonth.val(), baseDOBDay.val());
    });

    baseDOBDay.on('keyup', function () {
      console.log(
        baseDOBYear.val() + '-' + baseDOBMonth.val() + '-' + $(this).val(),
      );
      setDOB(baseDOBYear.val(), baseDOBMonth.val(), $(this).val());
    });

  }
}
export default subscribeForm;
